import React from 'react';
import ReactECharts from 'echarts-for-react';

type ConfusionMatrixProps = {
  data: {
    labels: string[];
    matrix: number[][];
  };
};

const ConfusionMatrixHeatmap: React.FC<ConfusionMatrixProps> = ({ data }) => {
  // Ensure data.matrix is defined and is an array before calling flatMap
  const chartData = Array.isArray(data.matrix)
    ? data.matrix.flatMap((row, i) =>
        row.map((value, j) => [j, i, value]) // [x, y, value]
      )
    : []; // Fallback to an empty array if data.matrix is undefined or not an array

    const option = {
      title: {
        text: 'Confusion Matrix',
        left: 'center',
        textStyle: { fontSize: 20 }
      },
      tooltip: {
        position: 'top',
        formatter: (params: any) => {
          if(params?.data){
          const [x, y, val] = params.data;
          return `Actual: ${data.labels[y]}<br>Predicted: ${data.labels[x]}<br>Value: ${val}`;
        }
        },
        z: 9999
      },
      grid: {
        top: 60,
        bottom: 80, // more space for bottom slider
        right: 100,  // more space for visualMap and right slider
        left:   100
      },
      xAxis: {
        type: 'category',
        data: data?.labels,
        splitArea: { show: true },
        name: 'Predicted Label',
        nameLocation: 'center',
        nameGap: 40,
        nameTextStyle: {
          fontSize: 14,
          fontWeight: 'bold',
          align: 'center'
        },
        axisLabel: {
          rotate: 90,
          formatter: (value)=>{
            if(value){
            return value.length > 3 ? value.slice(0, 3) + '…' : value
          }
          }
        }
      },
      yAxis: {
        type: 'category',
        data: data.labels,
        splitArea: { show: true },
        name: 'Actual Label',
        nameLocation: 'center',
        nameGap: 50,
        nameRotate: 270,
        nameTextStyle: {
          fontSize: 14,
          fontWeight: 'bold',
          align: 'center'
        },
        axisLabel: {
          rotate: 0,
          formatter:  (value)=>{
            if(value){
            return value.length > 3 ? value.slice(0, 3) + '…' : value
          }
          }
        },
        inverse: true // Reverse the y-axis
      },      
      visualMap: {
        min: 0,
        max: 87,
        calculable: true,
        orient: 'vertical',
        left: '90%',     // move visual map further right
        top: 'center',
        inRange: {
          color: ['#deebf7', '#3182bd', '#08519c']
        }
      },
      series: [
        {
          name: 'Confusion Matrix',
          type: 'heatmap',
          data: chartData,
          label: {
            show: true,
            color: '#000'
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(0,0,0,0.5)'
            }
          }
        }
      ],
      dataZoom: [
        {
          type: 'inside',
          xAxisIndex: 0,
          yAxisIndex: 0,
          zoomOnMouseWheel: true,
          moveOnMouseMove: true,
          moveOnMouseWheel: true,
        },
        {
          type: 'slider',
          xAxisIndex: 0,
          height: 15,
          bottom: 10 // raise above grid bottom
        },
        {
          type: 'slider',
          yAxisIndex: 0,
          width: 15,
          right: 0 // leave space for visualMap
        }
      ]
    };
    

  return (
    <div style={{ width: '90%', height: '50vh', margin: '0 auto' }}>
      <ReactECharts option={option} style={{ height: '100%', width: '100%' }} />
    </div>
  );
};

export default ConfusionMatrixHeatmap;
